import React, { useEffect, useMemo, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Visibility } from '@material-ui/icons';

import moment from 'moment';

import { format, setHours, setMinutes, setSeconds, parseISO } from 'date-fns';

import { UnidataTable } from '~/components';
import { recordFiltering } from '~/store/modules/operacaoconsultaimpedimentos/actions';

import ListaImpedimentos from './components/ListaImpedimentos';

function OperacaoConsultaImpedimentosLista() {
  const dispatch = useDispatch();

  const buttons = [];

  const operacaoconsultaimpedimentos = useSelector(
    (state) => state.operacaoconsultaimpedimentos
  );
  const listaImpedimentosRef = useRef(null);

  const handleUpdate = React.useCallback(async () => {
    await dispatch(recordFiltering(operacaoconsultaimpedimentos.params));
  }, [operacaoconsultaimpedimentos]);

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const filter = useMemo(
    () => [
      {
        id: 'data_cadastro_ini',
        label: 'Data Inicial',
        type: 'initialdatetime',
        defaultValue: datahorainicial,
      },
      {
        id: 'data_cadastro_fim',
        label: 'Data final',
        type: 'finaldatetime',
        defaultValue: datahorafinal,
      },
    ],
    [datahorainicial, datahorafinal]
  );

  const header = React.useMemo(
    () => [
      {
        id: 'veic_placa_apresentacao',
        label: 'Veículo',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'poco_desc_abrev',
        label: 'Posto',
        align: 'left',
      },
      {
        id: 'orga_nome',
        label: 'Órgão',
        align: 'left',
      },
      {
        id: 'unid_nome',
        label: 'Cód Unidade',
        align: 'left',
      },
      {
        id: 'cond_cpf',
        label: 'CPF Condutor',
        align: 'left',
      },
      {
        id: 'cond_nome',
        label: 'Nome Condutor',
        align: 'left',
      },
      {
        id: 'imab_data_registro',
        label: 'Data Registro',
        formatted: (value) =>
          value !== null ? moment(value).format('DD/MM/YYYY HH:mm') : '-',
        align: 'left',
      },
      {
        id: 'imab_data_liberacao',
        label: 'Data Liberação',
        formatted: (value) =>
          value !== null ? moment(value).format('DD/MM/YYYY HH:mm') : '-',
        align: 'left',
      },
      {
        id: 'usua_nome',
        label: 'Nome Gestor',
        align: 'left',
      },
      {
        id: 'desc_tipo',
        label: 'Tipo',
        align: 'left',
      },
      {
        id: 'desc_liberado',
        label: 'Status',
        align: 'left',
      },
      {
        id: 'imab_obs',
        label: 'OBS',
        align: 'left',
      },
    ],
    []
  );

  const headerOperacaoConsultaImpedimentosForm = useMemo(() => [
    buttons.push({
      title: 'Lista de Impedimentos',
      action: (value) => listaImpedimentosRef.current.handleToggleModal(value),
      icon: <Visibility />,
    }),
  ], []);



  return (
    <>
      <UnidataTable
        fixed
        pdf
        excel
        reportOrder="imab_data_registro ASC"
        create={false}
        delete={false}
        update={false}
        header={header}
        custom={filter}
        redux={operacaoconsultaimpedimentos}
        read={recordFiltering}
        actions={buttons}
        detach="veic_placa_apresentacao"
        key="veic_placa_apresentacao"
        view="VW_IMPEDIMENTO_ABASTECIMENTO"
        reportTitle="Consulta Impedimentos"
      />

      <ListaImpedimentos
        ref={listaImpedimentosRef}
        update={() => handleUpdate()}
        name="ListaImpedimentos"
      />

    </>
  );
}

export default OperacaoConsultaImpedimentosLista;
